// extracted by mini-css-extract-plugin
export var list = "shopItemAttributesList-module--list--wuovX";
export var listItem = "shopItemAttributesList-module--list-item--eBsoQ";
export var title = "shopItemAttributesList-module--title--+mbTs";